export default __webpack_public_path__ + "a53c971.png";